import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  
];

@NgModule({
    imports: [
      CommonModule,
      RouterModule.forRoot(routes,{ useHash: true })
    ],
    declarations: [],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }